(function() {
    //angular.module('st').requires.push('ngVis');
    angular.module('st').requires.push('cstudioApp.services');
    angular.module('st').requires.push('cstudioApp.filters');
    angular.module('st').requires.push('cstudioApp.directives');
    angular.module('st').requires.push('cstudioApp.controllers');
    angular.module('st').requires.push('ui.bootstrap');

    //angular.module("cstudioApp.controllers", ['ngVis', 'ngAnimate']);
    angular.module("cstudioApp.controllers", ['ngAnimate']);
    angular.module("cstudioApp.services", []);
    angular.module("cstudioApp.filters", []);
    angular.module("cstudioApp.directives", []);

    //timelines next
    //http://visjs.org/docs/timeline/#Example


    //console.info("instantiated");

    //function MovieController($scope, $compile, $timeout, $http, VisDataSet) {
    function MovieController($scope, $compile, $timeout, $http, $q) {
        //console.info("controller loaded");
        let GET_ALL_SJO_DATA = false;
        let SJO_DATA_AND_CACHE_ENABLED = false;

        var mvm = this;
        mvm.ALLOW_GET_ALL_SJO_DATA = false;
        mvm.hello = "hello world";
        mvm.CURRENT_DATE = moment().format('MMM Do YYYY');
        mvm.CURRENT_DATE_URL = moment().format('YYYY-MM-DD');
        mvm.showTimeline = false;
        mvm.buildingTimeline = true;
        mvm.filteredItemsVariable = [];
        mvm.dates = [];
        mvm.dateArray = [];
        mvm.Datelimit = 0;
        mvm.hasShowTimes = false;
        mvm.movieFormatCodes = null;
        //var movieObj = movieData.slice(0, 20);
        mvm.filterByPlayingType = 'nowplaying';
        mvm.NowPlayingTab = true;
        var CINEMAS = [];
        var ORIGINAL_SHOWTIMES = [];
        var SHOWTIMES = [];
        var ORIGINAL_MOVIES = [];
        var MOVIES = [];
        //var TIMELINE = new vis.DataSet();
        //var ITEMS = new vis.DataSet();
        var TIMELINE = [];
        var ITEMS = [];

        var CALENDAR_DATA = {
            max_date: moment(),
            min_date: moment(),
            all_dates: []
        };
        mvm.SHOWTIMES_WITH_STATUSES = {};
        mvm.showtimeSelectedDate = moment().format('YYYY-MM-DD');
        //console.log('selected dated', mvm.showtimeSelectedDate);
        mvm.isNowPlaying = true;
        mvm.isComingSoon = false;
        mvm.isLoading = true;
        //mvm.isLoading = true;

        var counter = 0;
        var counter2 = 0;
        var SELECTED_DATE = moment();
        mvm.nextDay = nextDay;
        mvm.prevDay = prevDay;

        mvm.sortorder = "+FilmTitle";

        $scope.$watch('mvm.filterByCinemaLocation', function(newValue, oldValue) {
            if (newValue) {
                mvm.filterByCinemaLocation = newValue;
                //console.log('cinema', newValue);
                $("#share-film-cinema").val(newValue);
            } else {
                mvm.filterByCinemaLocation = undefined;
                $("#share-film-cinema").val('');
            }
        });


        mvm.filterByMultipleMovieFormats = function(item) {
            //console.log(item, mvm.filterByMovieFormat);
        };

        $scope.$watch('mvm.filterByMovieFormat', function(newValue, oldValue) {
            if (newValue) {
                mvm.filterByMovieFormat = newValue;
                //console.log('format', newValue);
                $("#share-film-format").val(newValue);
            } else {
                mvm.filterByMovieFormat = undefined;
                $("#share-film-format").val('');
            }
        });


        mvm.next = function() {
            if ((mvm.Datelimit + 4 === mvm.dateArray.length) || (mvm.Datelimit + 4 >= mvm.dateArray.length)) {
                return;
            } else {
                mvm.Datelimit += 1;
            }

        };

        mvm.prev = function() {
            if (mvm.Datelimit === 0) {
                mvm.Datelimit = 0;
            } else {
                mvm.Datelimit -= 1;
            }
        };

        mvm.getFilteredItemsVariable = function() {
            return mvm.filteredItemsVariable;
        };

        function nextDay() {
            SELECTED_DATE = moment(SELECTED_DATE).add(1, 'days');
            //console.log(SELECTED_DATE);
            buildTimeline();
        }

        function prevDay() {
            SELECTED_DATE = moment(SELECTED_DATE).add(-1, 'days');
            //console.log(SELECTED_DATE);
            buildTimeline();
        }

        function getCount() {
            return ++counter;
        }

        function getCount2() {
            return ++counter2;
        }

        function getMomentFromTimeString(str) {
            var t = moment(str, 'HH:mm A');
            // Now t is a moment.js object of today's date at the time given in str

            if (t.get('hour') < 22) // If it's before 9 pm
                t.add('d', 1); // Add 1 day, so that t is tomorrow's date at the same time

            return t;
        }

        function checkCalendarInformation(start, end) {
            //check min and max date
            CALENDAR_DATA.min_date = start.isBefore(CALENDAR_DATA.min_date) ? start : CALENDAR_DATA.min_date;
            CALENDAR_DATA.max_date = end.isAfter(CALENDAR_DATA.max_date) ? end : CALENDAR_DATA.max_date;

            var startOfDay = moment(start).clone().format('YYYY-MM-DD');
            if (CALENDAR_DATA.all_dates.indexOf(startOfDay) === -1) {
                CALENDAR_DATA.all_dates.push(startOfDay);
            }
        }

        function addTheatersFromFilm(movie, movieGroupId) {
            var showTimes = _.find(SHOWTIMES, { 'FilmId': movie.FilmId });
            var cinemaIds = [];

            _.forOwn(showTimes.Cinemas, function(cinema, cinemaName) {
                var cinemaVistaId = getCount();

                var itemsAdded = false;


                _.each(cinema, function(showing) {
                    //var itemObj = {};
                    //console.log('showing', showing, movie);
                    var startOfDay = moment(showing.DateTime).clone().startOf('day');
                    var start = moment(showing.DateTime).clone();
                    var end = start.clone().add(movie.RunTime, 'minutes');
                    checkCalendarInformation(start, end);
                    if (SELECTED_DATE.startOf('day').isSame(startOfDay)) {
                        var showingVistaId = getCount2();

                        var itemContent = "";
                        itemContent = "<div class='showtime-template'><div class='square-grid'><div class='checkered-bg'></div></div><div class='time'>" + moment(start).format("LT") + "</div><div class='type'>IMAX</div><div class='event'>$</div></div>";

                        //add ID so that we know this theatre has a showing for the selected date
                        ITEMS.add({
                            id: showingVistaId,
                            group: cinemaVistaId,
                            content: itemContent,
                            start: start,
                            end: end,
                            type: 'range'
                        });
                        itemsAdded = true;
                    } else {
                        // They are not on the same day
                    }
                });

                //only cinema row if a movie is playing for them
                if (itemsAdded) {
                    TIMELINE.add({
                        id: cinemaVistaId,
                        content: getCinemaDetails(cinema, cinemaName),
                    });

                    cinemaIds.push(cinemaVistaId);
                }
            });
            return cinemaIds;
        }

        function buildTimeline() {

            //console.log('3 A');
            mvm.buildingTimeline = true;
            //RESET DATA
            //TIMELINE = new vis.DataSet();
            //ITEMS = new vis.DataSet();
            TIMELINE = [];
            ITEMS = [];
            CALENDAR_DATA.min_date = moment();
            CALENDAR_DATA.max_date = moment();
            CALENDAR_DATA.all_dates.length = 0;
            MOVIES = _.clone(ORIGINAL_MOVIES, true);
            //console.log('loaded 3', MOVIES);
            SHOWTIMES = _.clone(ORIGINAL_SHOWTIMES, true);
            counter = 0;
            counter2 = 0;

            mvm.movies = MOVIES;

            CALENDAR_DATA.all_dates.sort();

        }

        function getCinemaDetails(cinema, cinemaName) {
            var htmlStart = "<div class='timeline-cinema-parent-container'><div class='row'>";
            var detailsEnd = htmlStart + "<div class='title'>" + cinemaName + "</div>";
            var htmlEnd = detailsEnd + "</div></div>";
            return htmlEnd;
        }

        mvm.filteredItemsCinemaLocation = function(items) {
            //mvm.filterByCinemaLocation = undefined;
            //mvm.filterByMovieFormat = undefined;
            //console.log('filtered pre', items);
            var result = {};
            mvm.filteredItemsVariable = [];
            angular.forEach(items, function(value, key) {
                var byFilm = _.get(value, 'currentShowtimes.byFilm');
                //console.log(key, value, byFilm);

                angular.forEach(byFilm, function(value2, key2) {
                    delete value2['Formats'];
                    delete value2['undefined'];

                    angular.forEach(value2, function(value3, key3) {
                        //console.log(key3,value3)
                        if (value3.Date === mvm.showtimeSelectedDate) {
                            result[key2] = result[key2] || [];
                            result[key2].push(value3);
                        }
                    });
                    //console.log('result', result);
                    //if (result[key2]) {
                    //    result[key2]['Formats'] = _.groupBy(result[key2], 'FormatCode');
                    //}
                    if (result[key2]) {
                        result[key2]['Formats'] = _.groupBy(result[key2], 'FormatCode');

                        var temp = [];
                        _.forOwn(result[key2]['Formats'], function(f, v) {
                            var temp2 = _.map(f, function(o) { return _.extend({ 'FormatType': v.trim() }, o) });
                            temp.push(temp2);
                        });

                        result[key2]['Formats'] = temp;
                    }
                });
            });

            //console.log('filtered post', result);
            var a = Object.keys(result).map(function(key) {
                var temp = {};
                temp['Title'] = key;
                temp['Formats'] = _.clone(result[key]['Formats']);
                temp['HOFilmCode'] = _.get(result[key], '[0][FilmID]');
                return temp;
            });

            $scope.$evalAsync(function() {
                //convert to array for filtering/sorting
                var arr = _.clone(a);

                var t = [];
                _.each(result, function(o) { _.forOwn(o['Formats'], function(f) { t = t.concat(f); }); });

                mvm.movieFormatFilterArray = _(t).map('FormatCode').uniq().value().map(Function.prototype.call, String.prototype.trim);

                var arr2 = [];
                _.each(arr, function(e) {
                    var g;
                    var aItem = _.find(t, function(a) { return a.FilmID === e.HOFilmCode; });
                    g = _.merge({}, e, aItem);
                    g['FilmTitle'] = mvm.filmKey[g.ScheduledFilmId].Title;
                    g['Title'] = mvm.filmKey[g.ScheduledFilmId].Title;
                    g['KeyCombo'] = g.FilmID + g.CinemaID + g.FormatCode;
                    g['ReleaseDateDT'] = mvm.filmKey[g.FilmID].ReleaseDateDT;
                    g['HOFilmCode'] = g.FilmID;
                    aItem = null;
                    formats = null;
                    arr2.push(g);
                });

                mvm.filteredItemsVariable = arr2;
                //console.log('filtered', mvm.filteredItemsVariable);
                mvm.hasShowTimes = _.isEmpty(mvm.filteredItemsVariable, true) ? false : true;
            });
        };
        mvm.addToWatchlist = function(filmCode, event) {
            event.preventDefault();

            $http.post("/rpc/membership/account/watchlist/add/" + filmCode)
                .then(function(data) {
                    if (data.data.Success == true) {
                        $scope.isInWatchlist = true;
                        // success
                    } else {
                        // vista error
                        alert('Error occurred while adding film to the watchlist.')
                    }
                }).catch(function(error) {
                    // our server error
                    alert('Error occurred while adding film to the watchlist.')
                })
        }

        mvm.removeFromWatchlist = function(filmCode, event) {
            event.preventDefault();

            $http.post("/rpc/membership/account/watchlist/remove/" + filmCode)
                .then(function(data) {
                    if (data.data.Success == true) {
                        $scope.isInWatchlist = false;
                        // success
                    } else {
                        // vista error
                        alert('Error occurred while adding film to the watchlist.')
                    }
                }).catch(function(error) {
                    // our server error
                    alert('Error occurred while adding film to the watchlist.')
                })
        }

        mvm.initWatchlist = function(filmCode) {
            $scope.isInWatchlist = false;
            $scope.showWatchlistLink = false;

            $http.get("/rpc/membership/account/watchlist")
                .then(function(data) {
                    if (data.data.Success == true) {
                        // success
                        $scope.showWatchlistLink = true;

                        for (var i = 0; i < data.data.Data.length; i++) {
                            var film = data.data.Data[i];
                            if (film.HOFilmCode == filmCode) {
                                $scope.isInWatchlist = true;
                            }
                        }
                    }
                })
        }

        mvm.filteredItemsHomePage = function(items) {
            //mvm.filterByCinemaLocation = undefined;
            //mvm.filterByMovieFormat = undefined;
            //console.log('filtered pre', items);
            var result = {};
            mvm.filteredItemsVariable = [];
            angular.forEach(items, function(value, key) {
                var byFilm = _.get(value, 'currentShowtimes.byCinema');
                //console.log(key, value, byFilm);

                angular.forEach(byFilm, function(value2, key2) {
                    delete value2['Formats'];
                    delete value2['undefined'];

                    angular.forEach(value2, function(value3, key3) {
                        //console.log(key3,value3)
                        if (value3.Date === mvm.showtimeSelectedDate) {
                            result[key2] = result[key2] || [];
                            result[key2].push(value3);
                        }
                    });
                    //console.log('result', result);
                    if (result[key2]) {
                        result[key2]['Formats'] = _.groupBy(result[key2], 'FormatCode');
                    }
                });
            });

            //console.log('filtered post', result);

            $scope.$evalAsync(function() {
                var t = [];
                _.each(result, function(o) { _.forOwn(o['Formats'], function(f) { t = t.concat(f); }); });

                mvm.movieFormatFilterArray = _(t).map('FormatCode').uniq().value().map(Function.prototype.call, String.prototype.trim);
                var cinemaIdsInList = _(t).map('CinemaID').uniq().value().map(Function.prototype.call, String.prototype.trim);

                mvm.cinemaFilterArray = _(mvm.cinemaKeyArray)
                    .keyBy('VistaID')
                    .at(cinemaIdsInList)
                    .value();

                var now = moment();

                _.each(t, function(e) {
                    e['FilmTitle'] = mvm.filmKey[e.ScheduledFilmId].Title;
                    e['KeyCombo'] = e.FilmID + e.CinemaID + e.FormatCode;
                    //TODO nowplayinglogic
                    //e['PlayingType'] = moment(mvm.filmKey[e.ScheduledFilmId].ReleaseDateDT).isSameOrAfter(now) ? 'comingsoon' : 'nowplaying';
                    e['PlayingType'] = 'nowplaying';
                    e['ReleaseDateDT'] = mvm.filmKey[e.ScheduledFilmId].ReleaseDateDT;

                    try {
                        e['ReleaseDateDT'] = moment(mvm.filmKey[e.ScheduledFilmId].ReleaseDateDT).unix();
                    } catch (err) {}

                    e['RunTime'] = 0;
                    try {
                        let runtimeinseconds = mvm.filmKey[e.ScheduledFilmId].Duration;
                        if (runtimeinseconds) {
                            //convert something like 1h 22m into 1:22
                            var b = runtimeinseconds.replace('h', ':');
                            var c = b.replace('m', '');
                            var d = c.replace(' ', '');
                            //convert something like 1:22 into 82 seconds
                            e['RunTime'] = +(d.split(':').reduce((acc, time) => (60 * acc) + +time));
                            console(runtimeinseconds, e['RunTime']);
                        }
                    } catch (err) {}
                });

                //mvm.filteredItemsVariable = _.uniqBy(t, 'ScheduledFilmId');

                mvm.filteredItemsVariable = t;
                //console.log('filtered', mvm.filteredItemsVariable);
                mvm.hasShowTimes = _.isEmpty(mvm.filteredItemsVariable, true) ? false : true;
            });

        };

        mvm.ShowNowPlaying = function() {
            mvm.ComingSoonTab = false;
            mvm.NowPlayingTab = true;
            mvm.filterByPlayingType = 'nowplaying';
            //AOS.init(); 

            $timeout(function() {
                AOS.refreshHard();
            }, 0);
        };
        mvm.ShowComingSoon = function() {
            mvm.NowPlayingTab = false;
            mvm.ComingSoonTab = true;
            mvm.filterByPlayingType = 'comingsoon';

            $timeout(function() {
                //jQuery('.coming-soon-container').addClass("aos-animate");   
                AOS.refreshHard();
            }, 0);
        };

        function getTimelineDetails(movie, vistaID) {
            var newScope = $scope.$new(true);
            newScope.movie = movie;
            newScope.showImage = 'false';
            var dirCode = "<movie-poster-information movie='movie' align-text=" + 'left' + "></movie-poster-information>";

            var htmlStart = "<div class='timeline-content-parent-container'><div class='row'>";
            var img = htmlStart + "<div class='timeline-image'><img class='timeline-movie-poster' ng-src='{{movie.Img}}' /></div>";
            var detailsStart = img + "<div class='timeline-details'>";
            var movieDirective = detailsStart + dirCode;
            var detailsEnd = movieDirective + "</div>";
            var htmlEnd = detailsEnd + "</div></div>";
            var compiled = $compile(htmlEnd)(newScope);

            $timeout(function() {
                //wait for digest cycle to finish, function has already finished though
                //so we have to remove/add in the new/compiled content HTML object
                //console.info("clone", ggroups, vistaID);
                var copy = _.clone(ggroups._data[vistaID], true);
                if (typeof copy !== "undefined") {
                    copy.content = compiled[0].outerHTML;
                    mvm.data.groups.remove(vistaID);
                    mvm.data.groups.add(copy);
                }
            }, 0);

            return htmlEnd;
        }


        //disable for now
        mvm.routeParams = function() {
            var params = "?date=";
            params += mvm.CURRENT_DATE_URL;
            if (mvm.filterByCinemaLocation) {
                params += "&cinema=" + encodeURIComponent(mvm.filterByCinemaLocation);
            }
            if (mvm.filterByMovieFormat) {
                params += "&format=" + encodeURIComponent(mvm.filterByMovieFormat);
            }

            //console.log('route params', params);
            return params;
        };


        mvm.setButtonClass = function($index) {
            var obj = mvm.dateArray[$index + mvm.Datelimit];
            $scope.selectedTab = moment(obj.Moment).format("YYYY-MM-DD");
        };

        mvm.getButtonClass = function($index) {
            var obj = mvm.dateArray[$index + mvm.Datelimit];
            return (moment(obj.Moment).format("YYYY-MM-DD") === $scope.selectedTab) ? 'active' : "";
        };

        mvm.getNowPlayingClass = function(name) {
            return (name === mvm.filterByPlayingType) ? 'active' : "";
        };

        mvm.filteredItemsByFilm = function(items) {
            var result = {};
            mvm.filteredItemsVariable = [];

            angular.forEach(items, function(value, key) {
                delete value['Formats'];
                delete value['undefined'];

                angular.forEach(value, function(value2, key2) {
                    //console.log(key2, value2);
                    if (value2.Date === mvm.showtimeSelectedDate) {
                        result[key] = result[key] || [];
                        result[key].push(value2);
                    }
                });
                //console.log('result', result);
                if (result[key]) {
                    result[key]['Formats'] = _.groupBy(result[key], 'FormatCode');

                    var temp = [];
                    _.forOwn(result[key]['Formats'], function(f, v) {
                        var temp2 = _.map(f, function(o) { return _.extend({ 'FormatType': v.trim() }, o) });
                        temp.push(temp2);
                    });

                    result[key]['Formats'] = temp;
                }
            });

            $scope.$evalAsync(function() {
                var t = [];

                var arr = _.values(result);

                _.each(result, function(o) { _.forOwn(o['Formats'], function(f) { t = t.concat(f); }); });

                mvm.movieFormatFilterArray = _(t).map('FormatCode').uniq().value().map(Function.prototype.call, String.prototype.trim);

                var cinemaIdsInList = _(t).map('CinemaID').uniq().value().map(Function.prototype.call, String.prototype.trim);

                mvm.cinemaFilterArray = _(mvm.cinemaKeyArray)
                    .keyBy('VistaID')
                    .at(cinemaIdsInList)
                    .value();

                var arr2 = [];
                _.each(arr, function(e) {
                    var g;
                    var cinema = mvm.cinemaKey[e[0].CinemaID];
                    g = _.merge({}, e, cinema);
                    g['FilmID'] = g[0]['FilmID'];
                    g['KeyCombo'] = g.FilmID + g.VistaID;
                    g['CinemaID'] = g['VistaID'];
                    g['MovieFormats'] = Object.keys(e.Formats).map(Function.prototype.call, String.prototype.trim);
                    arr2.push(g);
                });

                mvm.filteredItemsVariable = arr2;
                //console.log('filtered', mvm.filteredItemsVariable);
                mvm.hasShowTimes = _.isEmpty(mvm.filteredItemsVariable, true) ? false : true;
            });

        };

        function loadFirstTimeData(data) {
            //console.log('2 A');
            if (!data) {
                return;
            }
            //console.log('acc data', data);
            //console.log('load first', data);
            ORIGINAL_MOVIES = data.reduce(function(acc, item) {
                acc.push({
                    "FilmId": item.FilmId,
                    "Title": item.Title,
                    "Cert": item.Cert,
                    "Img": item.Img,
                    "Trailer": item.Trailer,
                    "ReleaseDate": item.ReleaseDate,
                    "RunTime": item.RunTime,
                    "Rating": item.Rating,
                    "Genres": item.Genres,
                    "Synopsis": item.Synopsis,
                    "Teaser": item.Teaser,
                    "Cast": item.Cast,
                    "Director": item.Director,
                    "FriendlyName": item.FriendlyName,
                    "foregroundImage": item.Img,
                    "currentShowtimes": item.currentShowtimes

                });
                return acc;
            }, []);
            //console.log('load second', ORIGINAL_MOVIES);
            //console.log('1 show', data);
            ORIGINAL_SHOWTIMES = data.reduce(function(acc, item) {
                acc.push({
                    "Title": item.Title,
                    "FilmId": item.FilmId,
                    "currentShowtimes": item.currentShowtimes,
                    "TicketsSellingFast": item.TicketsSellingFast,
                    "ShowSoldOut": item.ShowSoldOut,
                    "EventName": item.EventName,
                    "hasEvent": item.hasEvent,
                    "ShowtimeDetailUrl": item.ShowtimeDetailUrl,
                    "OverrideShowtimeIcon": item.OverrideShowtimeIcon,
                    "OverrideShowtimeIconDescription": item.OverrideShowtimeIconDescription,
                    "OverrideShowtimeIconKey": item.OverrideShowtimeIconKey,
                    "OverrideShowtimeIconDescriptionKey": item.OverrideShowtimeIconDescriptionKey,
                    "OverrideShowtimeIconKeyOrder": item.OverrideShowtimeIconKeyOrder
                });
                return acc;
            }, []);

            //Compile list of theatres based on data
            _.each(SHOWTIMES, function(time) {
                _.each(time.Dates, function(date) {
                    var ary = Object.keys(date);
                    CINEMAS.push(ary);
                });
            });

            CINEMAS = _(CINEMAS).flattenDeep().uniq().value();
            //console.log('2 B');
        }


        function randomScore() {
            return Math.floor(Math.random() * 100);
        }

        function randomHours() {
            return Math.floor(Math.random() * 10);
        }

        var handleSuccess = function(data, status) {
            //console.log('1');
            loadFirstTimeData(data);
            buildTimeline(data);
            $timeout(function() { mvm.buildingTimeline = false; }, 0);
            $scope.$evalAsync(mvm.pageLoaded = true);
            //buildCalendarPicker()
        };

        function setWithExpiry(key, value, ttl) {
            const now = new Date()

            // `item` is an object which contains the original value
            // as well as the time when it's supposed to expire

            //compress value            
            var compressedValue = value;
            compressedValue.data = JSON.stringify(compressedValue.data);
            compressedValue.calendarDates = JSON.stringify(compressedValue.calendarDates);
            compressedValue.films = JSON.stringify(compressedValue.films);
            compressedValue.dates = JSON.stringify(compressedValue.dates);
            compressedValue.cinemas = JSON.stringify(compressedValue.cinemas);
            //var compressedValue = JSON.stringify(value);

            //console.log('size of sjos: ' + roughSizeOfObject(compressedValue));

            const item = {
                value: compressedValue,
                expiry: now.getTime() + ttl,
            }
            //console.log(item);
            localStorage.setItem(key, JSON.stringify(item))
        }

        function getWithExpiry(key) {
            //remove old way if it still exists      
            let oldKey = "allsjos";
            const itemStrOld = localStorage.getItem(oldKey)
            if (itemStrOld) {
                localStorage.removeItem(oldKey)
            }

            const itemStr = localStorage.getItem(key)
            // if the item doesn't exist, return null
            if (!itemStr) {
                return null
            }
            const item = JSON.parse(itemStr)
            const now = new Date()
            // compare the expiry time of the item with the current time
            if (now.getTime() > item.expiry) {
                // If the item is expired, delete the item from storage
                // and return null
                localStorage.removeItem(key)
                return null
            }
            var timetogo = item.expiry - now.getTime();
            try {
                timetogo = timetogo / 1000;
                timetogo = timetogo.toString().split(".")[0];
                timetogo = timetogo + " seconds.";
            } catch (err) {
                timetogo = timetogo + " milliseconds."
            }
            //console.log('found cache for ' + key + '. Expires in ' + timetogo);
            return item.value
        }

        //caching size calculator
        function roughSizeOfObject(object) {

            var objectList = [];
            var stack = [object];
            var bytes = 0;

            while (stack.length) {
                var value = stack.pop();

                if (typeof value === 'boolean') {
                    bytes += 4;
                } else if (typeof value === 'string') {
                    bytes += value.length * 2;
                } else if (typeof value === 'number') {
                    bytes += 8;
                } else if (
                    typeof value === 'object' &&
                    objectList.indexOf(value) === -1
                ) {
                    objectList.push(value);

                    for (var i in value) {
                        stack.push(value[i]);
                    }
                }
            }
            return bytes;
        }

        function getBaseSJO(sjoID) {
            var deferred = $q.defer();
            getMoreDataAPI(sjoID)
                .then(function(response) {
                    if (response && response.data) {
                        var r = response.data.Data;
                        deferred.resolve(r);
                    }
                })
                .catch(function(response) {
                    deferred.resolve();
                })
                .finally(function(response) {

                });
            return deferred.promise;
        }

        function getMoreData(sjoID) {
            var deferred = $q.defer();
            getMoreDataAPI(sjoID)
                .then(function(response) {
                    if (response && response.data) {
                        var r = response.data.Data;
                        deferred.resolve(r);
                    }
                })
                .catch(function(response) {
                    deferred.resolve();
                })
                .finally(function(response) {

                });
            return deferred.promise;
        }

        function getMoreDataByTitle(sjoID) {
            var deferred = $q.defer();
            getMoreDataByTitleAPI(sjoID)
                .then(function(response) {
                    if (response && response.data) {
                        var r = response.data.Data;
                        deferred.resolve(r);
                    }
                })
                .catch(function(response) {
                    deferred.resolve();
                })
                .finally(function(response) {

                });
            return deferred.promise;
        }

        function getMoreDataAPIAll() {
            var config = {
                cache: true
            };
            var deferred = $q.defer();

            $http.get("/rpc/data/sjo/getAll", config).then(deferred.resolve);
            return deferred.promise;
        }


        function getMoreDataAPI(sjoid) {
            var config = {
                cache: true,
                params: {
                    id: sjoid
                }
            };
            var deferred = $q.defer();

            $http.get("/rpc/data/sjo/getSJO", config).then(deferred.resolve);
            return deferred.promise;
        }

        function getMoreDataByTitleAPI(sjoid) {
            var config = {
                cache: true,
                params: {
                    id: sjoid
                }
            };
            var deferred = $q.defer();

            $http.get("/rpc/data/sjo/getSJOByTitle", config).then(deferred.resolve);
            return deferred.promise;
        }

        //rivertownData.getAllData(handleSuccess);

        $scope.init = function(data, ShowtimeStatuses) {
            $scope.today();
            mvm.SHOWTIMES_WITH_STATUSES = {};

            if (ShowtimeStatuses) {
                var showtimesWithStatuses = ShowtimeStatuses;
                _.each(showtimesWithStatuses, function(s) {
                    mvm.SHOWTIMES_WITH_STATUSES[s.ID] = {
                        soldOut: s.ShowSoldOut,
                        sellingFast: s.TicketsSellingFast
                    };
                });
            }
            var newData = SitefinityToJs(data);

            mvm.hasShowtimesForSelecedDate();
            mvm.isLoading = false;
        };

        $scope.lazyLoadSJOCinemaDetail = function(sjoID, ShowtimeStatuses) {
            //console.log('lazy load params:', sjoID, ShowtimeStatuses);

            $scope.lazyLoadSetDay();
            //$scope.today();

            sjoID = sjoID.toString();
            if (sjoID.length === 1) {
                sjoID = "00" + sjoID;
            }

            if (sjoID.length === 2) {
                sjoID = "00" + sjoID;
            }

            mvm.SHOWTIMES_WITH_STATUSES = {};

            if (ShowtimeStatuses) {
                var showtimesWithStatuses = ShowtimeStatuses;
                _.each(showtimesWithStatuses, function(s) {
                    mvm.SHOWTIMES_WITH_STATUSES[s.ID] = {
                        soldOut: s.ShowSoldOut,
                        sellingFast: s.TicketsSellingFast
                    };
                });
            }

            //disable temporarily until json cleaned up
            let cachedItem = null;

            //if false then this view isnt caching its data
            let allSJOCacheKey = "sjo-allsjos";
            //cachedItem = getWithExpiry(allSJOCacheKey);


            if (cachedItem) {
                SitefinityToJs(cachedItem);
                mvm.hasShowtimesForSelecedDate();
                $scope.selectedTab = mvm.getTodaysSelectedTab();
                //console.log('selected Tab 1-1', $scope.selectedTab);
                mvm.isLoading = false;
            } else {
                getMoreDataByTitle(sjoID)
                    .then(function(response) {
                        SitefinityToJs(response);
                        mvm.hasShowtimesForSelecedDate();
                        $scope.selectedTab = mvm.getTodaysSelectedTab();
                        //console.log('selected Tab 1-2', $scope.selectedTab);
                        mvm.isLoading = false;
                    });

            }

        }

        $scope.lazyLoadSetDay = function () {
            //console.log('setting to today');
            $scope.today();
        }

        $scope.lazyLoadSJOHomepage = function(sjoIDLightweight, sjoIDFull, ShowtimeStatuses) {
            //console.log('lazy load params:', sjoIDFull, sjoIDLightweight, ShowtimeStatuses);

            //console.log('selected Tab 2-0-1', mvm.getTodaysSelectedTab());
            //$scope.today();
            $scope.lazyLoadSetDay();

            mvm.SHOWTIMES_WITH_STATUSES = {};

            if (ShowtimeStatuses) {
                var showtimesWithStatuses = ShowtimeStatuses;
                _.each(showtimesWithStatuses, function(s) {
                    mvm.SHOWTIMES_WITH_STATUSES[s.ID] = {
                        soldOut: s.ShowSoldOut,
                        sellingFast: s.TicketsSellingFast
                    };
                });
            }

            //disable temporarily until json cleaned up            
            let cacheKey = "sjo-allsjos";
            let cachedItem = null;

            //if false then this view isnt caching its data
            cachedItem = getWithExpiry(cacheKey);


            //console.log('selected Tab 2-0-2', mvm.getTodaysSelectedTab());

            if (cachedItem) {
                SitefinityToJs(cachedItem);
                mvm.hasShowtimesForSelecedDate();
                $scope.selectedTab = mvm.getTodaysSelectedTab();
                //console.log('selected Tab 2-1', $scope.selectedTab);
                mvm.isLoading = false;
            } else {
                getBaseSJO(sjoIDLightweight)
                    .then(function(baseresponse) {
                        SitefinityToJs(baseresponse);
                        mvm.hasShowtimesForSelecedDate();
                        $scope.selectedTab = mvm.getTodaysSelectedTab();
                        //console.log('selected Tab 2-2', $scope.selectedTab);
                        //mvm.isLoading = false;
                        getMoreData(sjoIDFull)
                            .then(function(response) {
                                try {
                                    if (cacheKey && response) {
                                        var tllMinutes = 30;
                                        var cacheTimeMilliseconds = tllMinutes * 1000 * 60;
                                        //console.log('caching: ' + cacheKey + " for " + cacheTimeMilliseconds + "ms");
                                        setWithExpiry(cacheKey, response, cacheTimeMilliseconds);
                                        //console.log('cached!');
                                    }
                                } catch (err) {
                                    //console.log('failed to cache', err);
                                }
                                SitefinityToJs(response);
                                //console.log('selected Tab 2-3', $scope.selectedTab);

                                //mvm.hasShowtimesForSelecedDate();
                                //$scope.selectedTab = mvm.getTodaysSelectedTab();
                                //console.log('selected Tab 2-4', $scope.selectedTab);

                                mvm.isLoading = false;
                                //mvm.hasShowtimesForSelecedDate();
                                //$scope.selectedTab = mvm.getTodaysSelectedTab();
                            });
                    });

            }

        }


        mvm.AOSRefresh = function() {
            jQuery(".now-playing-container").removeClass("aos-animate")
            $timeout(function() {
                AOS.refreshHard();
            }, 500);
        }

        mvm.hasShowtimesForSelecedDate = function() {
            return mvm.hasShowTimes;
        };

        mvm.formattedDate = function() {
            return moment($scope.dt).format('MMM Do YYYY');
        };


        $scope.today = function() {
            $scope.dt = new Date();
            mvm.showtimeSelectedDate = moment($scope.dt).format('YYYY-MM-DD');
        };


        $scope.clear = function() {
            $scope.dt = null;
        };

        mvm.DateChange = function(date) {
            var temp = moment(date).format('YYYY-MM-DD');
            mvm.CURRENT_DATE_URL = temp;
            mvm.CURRENT_DATE = moment(temp).format('MMM Do YYYY');
            $scope.$evalAsync(function() {
                $scope.selectedTab = temp.toString();

                var dateindex = _.findIndex(mvm.dateArray, { StringDate: moment(temp).format('YYYY-MM-DD') });
                //var modifier = dateindex <= 4 ? 0 : dateindex-3;
                //mvm.Datelimit = modifier;
                var sharedate = moment(temp).format('YYYY-MM-DD');
                $("#share-film-date").val(sharedate);
                mvm.Datelimit = dateindex;
            });
            mvm.showtimeSelectedDate = temp;

            jQuery(".now-playing-container").removeClass("aos-animate")
            $timeout(function() {
                AOS.refreshHard();
            }, 500);
            //console.log('date changed to: ', temp);
        };

        $scope.inlineOptions = {
            customClass: getDayClass,
            minDate: new Date(),
            showWeeks: true
        };
        var nextMonth = new Date();

        //calendar max date range, changing to 19 months (or 1.5 years ahead)
        nextMonth.setMonth(nextMonth.getMonth() + 19);

        $scope.dateOptions = {
            dateDisabled: disabledTest,
            formatYear: 'yy',
            maxDate: nextMonth,
            minDate: new Date(),
            startingDay: 1,
            showWeeks: false

        };

        // Disable weekend selection
        function disabled(data) {
            var date = data.date,
                mode = data.mode;
            return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
        }
        var dayDuration = 60 * 60 * 24 * 1000;

        function areDatesEqual(date1, date2) {
            return (parseInt(date1 / dayDuration)) === (parseInt(date2 / dayDuration));
        }
        //Disable all days but showtime days
        function disabledTest(data) {
            var date = data.date,
                mode = data.mode;

            var isRealDate = false;

            for (var i = 0; i < mvm.dates.length; i++) {
                //console.log('dates',mvm.dates);
                var momentDate = moment(mvm.dates[i]).toDate();
                if (areDatesEqual(momentDate, date)) {
                    isRealDate = true;
                }
            }

            return mode === 'day' && !isRealDate; // && (date >= $scope.endDate);
        }

        $scope.toggleMin = function() {
            $scope.inlineOptions.minDate = $scope.inlineOptions.minDate ? null : new Date();
            $scope.dateOptions.minDate = $scope.inlineOptions.minDate;
        };

        $scope.toggleMin();

        $scope.open1 = function() {
            $scope.popup1.opened = true;
        };

        $scope.open2 = function() {
            $scope.popup2.opened = true;
        };

        //WIP, this has to fire after all showtimes have been filtered somehow
        function tryToFixFilter(f) {
            //imax fix for showing other imax formats too
            console.log(mvm.filterByMovieFormat, f);
            const result = _.filter(f, (item) => item === mvm.filterByMovieFormat);
            if (_.isEmpty(result)) {
                //reset the filter if no results
                mvm.filterByMovieFormat = "";
                $scope.$applyAsync();
            } else {
                
            }
        }

        //this fix returns cards for if if we hit a page from IMAX events that isn't the same type of IMAX, so we return all IMAX options for any IMAX filter.
        //this is a joint fix with the movie-poster-information that shows the showtimes themselves, while this shows only the movie/cinema card part
        function imaxFilterFix(f) {
            //imax fix for showing other imax formats too
            var imax_keyword = "IMAX";
            if (mvm.filterByMovieFormat.indexOf(imax_keyword) > -1) {
                //if we are filtering by IMAX, then check for any IMAX type's on this current showtime
                const result = _.filter(f, (item) => item.includes(imax_keyword));
                //console.log('----results', result);
                if (!_.isEmpty(result)) {
                    //if we found at least one IMAX type of showing on this showtime then return it.
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        }

        mvm.filterByMultipleMovieFormatsFilmDetail = function(value) {
            var f = [];
            _.forOwn(value.Formats, function(v) { f.push(v[0].FormatCode.trim()); });
            if (!mvm.filterByMovieFormat) {
                return true;
            } else {
                if (f.indexOf(mvm.filterByMovieFormat) > -1) {
                    return true;
                } else {
                    //imax fix for showing other imax formats too
                    var hasOtherIMAXShowings = imaxFilterFix(f);
                    if (hasOtherIMAXShowings) {
                        return true;
                    } else {
                        return false;
                    }

                    //tryToFixFilter(f);
                    //return false;                    
                }
            }
        };

        mvm.filterByMovieFormatFunction = function(value) {
            var f = [];
            _.forOwn(value.Formats, function(v) { f.push(v[0].FormatCode.trim()); });
            if (!mvm.filterByMovieFormat) {
                return true;
            } else {
                if (f.indexOf(mvm.filterByMovieFormat) > -1) {
                    return true;
                } else {
                    //temp shelved idea that shows all IMAX showtimes with any IMAX format selected
                    //imax fix for showing other imax formats too
                    var hasOtherIMAXShowings = imaxFilterFix(f);
                    if (hasOtherIMAXShowings) {
                        return true;
                    } else {
                        return false;
                    }

                    //tryToFixFilter(f);
                    //return false;  
                }
            }
        };

        mvm.getTodaysSelectedTab = function() {
            return moment().format('YYYY-MM-DD');
        };
        mvm.setManualDate = function($index) {
            var obj = mvm.dateArray[$index + mvm.Datelimit];
            $scope.setDate(obj.Moment.year(), obj.Moment.month(), obj.Moment.date());
        };
        $scope.setDate = function(year, month, day) {
            //console.log('1', year, month, day);
            $scope.dt = new Date(year, month, day);
            mvm.showtimeSelectedDate = moment().year(year).month(month).date(day).format('YYYY-MM-DD');

            var date= moment().year(year).month(month).date(day).format('YYYY-MM-DD');
            $("#share-film-date").val(date);

            $scope.$evalAsync(function() {
                $scope.selectedTab = mvm.showtimeSelectedDate.toString();
                mvm.CURRENT_DATE_URL = mvm.showtimeSelectedDate;
                mvm.CURRENT_DATE = moment(mvm.showtimeSelectedDate).format('MMM Do YYYY');
            });
            //console.log(mvm.showtimeSelectedDate);
            //console.log('new date');
            jQuery(".now-playing-container").removeClass("aos-animate")
            $timeout(function() {
                AOS.refreshHard();
            }, 500);
        };

        $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        $scope.format = $scope.formats[0];
        $scope.altInputFormats = ['M!/d!/yyyy'];

        $scope.popup1 = {
            opened: false
        };

        $scope.popup2 = {
            opened: false
        };

        var tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        var afterTomorrow = new Date();
        afterTomorrow.setDate(tomorrow.getDate() + 1);



        function getDayClass(data) {
            var date = data.date,
                mode = data.mode;
            if (mode === 'day') {
                var dayToCheck = new Date(date).setHours(0, 0, 0, 0);

                for (var i = 0; i < $scope.events.length; i++) {
                    var currentDay = new Date($scope.events[i].date).setHours(0, 0, 0, 0);

                    if (dayToCheck === currentDay) {
                        return $scope.events[i].status;
                    }
                }
            }

            return '';
        }


        mvm.logs = {};

        function start() {
            startTime = new Date();
        }

        function end() {
            endTime = new Date();
            var timeDiff = endTime - startTime; //in ms
            // strip the ms
            timeDiff /= 1000;

            // get seconds 
            seconds = Math.round(timeDiff);
        }

        function SitefinityToJs(data) {
            var now = moment();

            //homepage is structured with cleaner json than other view, so re-string this since its re-used till other pages use showtimeVMHomepage class in sync
            try {
                var testParsed = JSON.parse(data);
                testParsed.data = _.isString(testParsed.data) ? testParsed.data : JSON.stringify(testParsed.data);
                testParsed.calendarDates = _.isString(testParsed.calendarDates) ? testParsed.calendarDates : JSON.stringify(testParsed.calendarDates);
                testParsed.films = _.isString(testParsed.films) ? testParsed.films : JSON.stringify(testParsed.films);
                testParsed.dates = _.isString(testParsed.dates) ? testParsed.dates : JSON.stringify(testParsed.dates);
                testParsed.cinemas = _.isString(testParsed.cinemas) ? testParsed.cinemas : JSON.stringify(testParsed.cinemas);
                data = testParsed;
            } catch (ex) {
                // execution continues here when an error was thrown. You can also inspect the `ex`ception object
            }

            var dataParsed = data;

            var updatedData = JSON.parse(dataParsed.data);

            _.each(updatedData, function(u) {
                delete u['TicketsOnSale'];
                _.forOwn(u['currentShowtimes'], function(g) {
                    delete g['TicketsOnSale'];
                });
                _.forOwn(u['Showtime'], function(g) {
                    delete g['TicketsOnSale'];

                    if (mvm.SHOWTIMES_WITH_STATUSES[g.Title]) {
                        g.ShowSoldOut = mvm.SHOWTIMES_WITH_STATUSES[g.Title].soldOut;
                        g.TicketsSellingFast = mvm.SHOWTIMES_WITH_STATUSES[g.Title].sellingFast;
                    }
                });
            });

            var calDates = JSON.parse(dataParsed.calendarDates);
            mvm.filmKey = JSON.parse(dataParsed.films);

            _.each(mvm.filmKey, function(u) {
                var tos = _.get(u, 'TicketsOnSale');
                if (tos) {
                    u['TicketsOnSale'] = moment(u['TicketsOnSale']).isBefore(now) ? true : false;
                } else {
                    u['TicketsOnSale'] = true;
                }
            });

            mvm.cinemaKey = JSON.parse(dataParsed.cinemas);
            mvm.cinemaKeyArray = _.values(mvm.cinemaKey);
            var tempdates = JSON.parse(dataParsed.dates);



            _.each(updatedData, function(e) {
                e.Showtime = _.filter(e.Showtime, function(j) {
                    var tempTime = moment(j.StartTime);
                    var diff = tempTime.diff(now, 'minutes');
                    //-11 is ~10 minutes past, so a showing at 12:00pm will still buy seeable/buyable at 12:10pm per Studio c
                    var TimePastShowtimeToKeepShowingShowtime = -11;
                    if (diff >= TimePastShowtimeToKeepShowingShowtime) {
                        return j;
                    } else {
                        j;
                    }
                });

            });


            //momentJS conversions
            calDates.forEach(function(el) {
                el['Moment'] = moment(el.Moment);
                el['StringDate'] = moment(el.Moment).format('YYYY-MM-DD');
            });

            var temparray = [];
            tempdates.forEach(function(d) {
                //var temp = d.split("-");
                //var datetime = moment().year(temp[0]).month(temp[1]).date(temp[2]);
                //datetime = datetime.subtract(1, 'month');
                var datetime = moment(d);
                if (moment(datetime).isBefore(moment(), 'day')) {
                    //dont include date
                } else {
                    var iscurrentDate = datetime.isSameOrAfter(moment(), "day");
                    if (iscurrentDate) {
                        temparray.push(d);
                    }
                }
            });

            mvm.dates = temparray;
            mvm.dateArray = calDates;

            mvm.calendarToday = {
                date: moment(),
                text: 'Today',
                dateString: moment().year() + ", " + moment().month() + ", " + moment().day()
            };
            mvm.calendarTomorrow = {
                date: moment(mvm.calendarToday.date).add(1, 'days'),
                text: moment(mvm.calendarToday.date).add(1, 'days').format('dddd'),
                dateString: moment(mvm.calendarToday.date).add(1, 'days').year() + ", " + moment(mvm.calendarToday.date).add(1, 'days').month() + ", " + moment(mvm.calendarToday.date).add(1, 'days').day()
            };
            mvm.calendarTomorrow2 = {
                date: moment(mvm.calendarToday.date).add(2, 'days'),
                text: moment(mvm.calendarToday.date).add(2, 'days').format('dddd'),
                dateString: moment(mvm.calendarToday.date).add(2, 'days').year() + ", " + moment(mvm.calendarToday.date).add(2, 'days').month() + ", " + moment(mvm.calendarToday.date).add(2, 'days').day()
            };

            mvm.DisablePrevButton = function () {
                //console.log('prev. datelimit:' + mvm.Datelimit + " | datearraylength: " + mvm.dateArray.length);
                return mvm.Datelimit === 0;
            }
            mvm.DisableNextButton = function () {
                //console.log('next. datelimit:' + mvm.Datelimit + " | datearraylength: " + mvm.dateArray.length);
                return (mvm.Datelimit + 4 === mvm.dateArray.length) || (mvm.Datelimit + 4 >= mvm.dateArray.length);
            }
            _.each(updatedData, function(m) {
                m['currentShowtimes']['byFormat'] = {};
                m['currentShowtimes']['byCinema'] = {};
                m['currentShowtimes']['byFilm'] = {};

                m['currentShowtimes']['byFormat'] = _.groupBy(m.Showtime, 'FormatCode');
                m['currentShowtimes']['byCinema'] = _.groupBy(m.Showtime, function(x) { return mvm.cinemaKey[x.CinemaID].Title });
                m['currentShowtimes']['byFilm'] = _.groupBy(m.Showtime, function(x) { return mvm.filmKey[x.FilmID].Title; });

                //console.log('cinemas', m['currentShowtimes']['byCinema']);

                _.forOwn(m['currentShowtimes']['byCinema'], function(value, key) {
                    m['currentShowtimes']['byCinema'][key]['Formats'] = _.groupBy(value, 'FormatCode');
                });

                _.forOwn(m['currentShowtimes']['byFilm'], function(value, key) {
                    m['currentShowtimes']['byFilm'][key]['Formats'] = _.groupBy(value, 'FormatCode');
                });

                //overrite index values with only key/values
                var temp = {};
                temp['byFormat'] = m['currentShowtimes']['byFormat'];
                temp['byCinema'] = m['currentShowtimes']['byCinema'];
                temp['byFilm'] = m['currentShowtimes']['byFilm'];
                m['currentShowtimes'] = temp;

                var tempAry = [];
                var momentToday = moment();
                var counter = 0;
                _.each(mvm.dates, function(d) {

                    var datetime = moment(d);
                    var obj = {
                        Text: moment(datetime).format("ddd M/D"),
                        Moment: datetime,
                        ID: counter,
                        StringDate: moment(datetime).format('YYYY-MM-DD')
                    };

                    var iscurrentDate = datetime.isSame(moment(), "day");
                    if (iscurrentDate) {
                        obj.Text = "Today";
                    }
                    var isTomorrowDate = datetime.isSame(moment().add(1, 'day'), "day");
                    if (isTomorrowDate) {
                        obj.Text = "Tomorrow";
                    }

                    if (moment(datetime).isBefore(moment(), 'day')) {
                        //its an old date, don't show it
                    } else {
                        tempAry.push(obj);
                    }
                    counter++;
                    //console.log(d, datetime);
                });

                //$scope.$evalAsync(function () {
                mvm.dateArray = tempAry;
                //});
                getQueryString = function() {
                    var key = false,
                        res = {},
                        itm = null;
                    // get the query string without the ?
                    var qs = location.search.substring(1);
                    // check for the key as an argument
                    if (arguments.length > 0 && arguments[0].length > 1)
                        key = arguments[0];
                    // make a regex pattern to grab key/value
                    var pattern = /([^&=]+)=([^&]*)/g;
                    // loop the items in the query string, either
                    // find a match to the argument, or build an object
                    // with key/value pairs
                    while (itm = pattern.exec(qs)) {
                        if (key !== false && decodeURIComponent(itm[1]) === key)
                            return decodeURIComponent(itm[2]);
                        else if (key === false)
                            res[decodeURIComponent(itm[1])] = decodeURIComponent(itm[2]);
                    }

                    return key === false ? res : null;
                }

                var dateparam = getQueryString("date");
                var cinemaparam = getQueryString("cinema");
                var formatparam = getQueryString("format");
                //console.log('params', dateparam, cinemaparam, formatparam);
                if (dateparam) {
                    var tempdate = moment(dateparam);
                    if (tempdate && tempdate.isValid()) {
                        //set calendar to this url param date
                        $scope.setDate(tempdate.year(), tempdate.month(), tempdate.date());

                        var dateindex = _.findIndex(mvm.dateArray, { StringDate: moment(tempdate).format('YYYY-MM-DD') });
                        //var modifier = dateindex <= 4 ? 0 : dateindex - 3;
                        //mvm.Datelimit = modifier;
                        mvm.Datelimit = dateindex;

                        if (mvm.dateArray.length <= 4) { 
                            mvm.Datelimit = 0;
                        } else {
                            var modifier = mvm.dateArray.length - dateindex;
                            var additionalDatesToShow = 4 - modifier;
                            
                            if (additionalDatesToShow >= 0) {
                                mvm.Datelimit = mvm.Datelimit - additionalDatesToShow;
                                console.log('modifier', modifier, additionalDatesToShow);
                            }
                        }

                        //console.log('date param', moment(tempdate).format('YYYY-MM-DD'));

                        //console.log('date index', dateindex, mvm.Datelimit, mvm.dateArray);
                    }
                } else {
                    if (mvm.dateArray && mvm.dateArray.length) {
                        tempdate = _.get(mvm.dateArray, '[0].Moment');
                        if (tempdate && tempdate.isValid()) {
                            $scope.setDate(tempdate.year(), tempdate.month(), tempdate.date());
                            
                            //console.log('temp date', tempdate);
                            dateindex = _.findIndex(mvm.dateArray, { StringDate: moment(tempdate).format('YYYY-MM-DD') });
                            //var modifier = dateindex <= 4 ? 0 : dateindex - 3;
                            //mvm.Datelimit = modifier;
                            mvm.Datelimit = dateindex;
                        }
                    }
                }

                if (cinemaparam) {
                    var cinema = decodeURIComponent(cinemaparam);
                    mvm.filterByCinemaLocation = cinema;
                    $("#share-film-cinema").val(cinemaparam);
                   //console.log('cinema param', cinemaparam);
                }

                if (formatparam) {
                    var format = decodeURIComponent(formatparam);
                    mvm.filterByMovieFormat = format;
                    $("#share-film-format").val(formatparam);
                   //console.log('format param', formatparam);
                }
                //console.log('ary', mvm.dateArray);
                //console.log('current showtimes', m['currentShowtimes']);
            });

            handleSuccess(updatedData);
        }

        function publishTimeline() {

            //console.log('4');

            window.ggroups = TIMELINE;
            window.gitems = ITEMS;

            mvm.data = { groups: TIMELINE, items: ITEMS };

            var gstart = new Date(SELECTED_DATE);
            // gstart.setHours(6, 0, 0, 0);
            gstart.setHours(9, 0, 0, 0);
            gstart = moment(gstart);

            var gend = new Date(SELECTED_DATE);
            gend.setHours(23, 59, 59, 999);
            gend = moment(gend);

            mvm.options = {
                format: {
                    minorLabels: function(date, scale, step) {
                        return "<strong>" + moment(date).format('h a') + "</strong>";
                    },
                    majorLabels: function(date, scale, step) {
                        return "<strong>" + moment(date).format('h a') + "</strong>";
                    }
                },
                min: gstart,
                max: gend,
                orientation: {
                    axis: "both"
                },
                timeAxis: {
                    scale: 'hour'
                },
                zoomable: false,
                horizontalScroll: true,
                moveable: true,
                stack: true,
                showCurrentTime: false,
                showMajorLabels: false,
                showMinorLabels: true,
                autoResize: true,
                zoomMax: 28800000 // 8 hours in milliseconds
            };


            mvm.onSelect = function(items) {
                //console.log(arguments);
                // debugger;
                //console.log('select');
            };

            mvm.onClick = function(props) {
                props.event.stopPropagation();
                props.event.preventDefault();

                var ignoreClick = props['what'] === 'group-label' ? true : false;
                if (ignoreClick) {
                    props.event.stopPropagation();
                    props.event.preventDefault();
                }
            };

            mvm.onDoubleClick = function(props) {
                // debugger;
                //console.log('DoubleClick');
            };

            mvm.rightClick = function(props) {
                //console.log('Right click!');
                props.event.preventDefault();
            };

            mvm.onRangeChange = function(props) {
                //console.log('on range change');
            };

            mvm.onRangeChanged = function(props) {
                //console.log('on range changed');
            };
            mvm.events = {
                rangechange: mvm.onRangeChange,
                rangechanged: mvm.onRangeChanged,
                onload: mvm.onLoaded,
                select: mvm.onSelect,
                click: mvm.onClick,
                doubleClick: mvm.onDoubleClick,
                contextmenu: mvm.rightClick
            };

            mvm.selectedDate = SELECTED_DATE.format("MM/DD");
            mvm.buildingTimeline = false;



            mvm.playingNow = function() {
                mvm.isComingSoon = false;
                mvm.isNowPlaying = true;
                //console.log('playing now');
            };

            mvm.comingSoon = function() {
                mvm.isNowPlaying = false;
                mvm.isComingSoon = true;
                //console.log('coming soon');
            };
        }
        //console.log('vis', vis);
        //console.log('mvm', mvm);       


    }
    MovieController.$inject = ["$scope", "$compile", "$timeout", "$http", "$q"];
    angular
        .module("cstudioApp.controllers")
        .controller("MovieController", MovieController);
})();

angular
    .module("cstudioApp.controllers")
    .filter('toArray', function() {
        return function(obj) {
            if (!(obj instanceof Object)) return obj;
            return _.map(obj, function(val, key) {
                return Object.defineProperty(val, '$key', { __proto__: null, value: key });
            });
        };
    });

angular
    .module("cstudioApp.controllers")
    .filter('unique', function() {
        return function(items, filterOn) {

            if (filterOn === false) {
                return items;
            }

            if ((filterOn || angular.isUndefined(filterOn)) && angular.isArray(items)) {
                var hashCheck = {},
                    newItems = [];

                var extractValueToCompare = function(item) {
                    if (angular.isObject(item) && angular.isString(filterOn)) {
                        return item[filterOn];
                    } else {
                        return item;
                    }
                };

                angular.forEach(items, function(item) {
                    var valueToCheck, isDuplicate = false;

                    for (var i = 0; i < newItems.length; i++) {
                        if (angular.equals(extractValueToCompare(newItems[i]), extractValueToCompare(item))) {
                            isDuplicate = true;
                            break;
                        }
                    }
                    if (!isDuplicate) {
                        newItems.push(item);
                    }

                });
                items = newItems;
            }
            return items;
        };
    });